import { translateFunc } from "client/utils/translateFunc";
import { Translate } from "components/common/Translate/Translate";
import { ColorScheme } from "./ColorScheme/ColorScheme";
import { Tabs } from "./Tabs/Tabs";
import { colorSchemes, initialSlide, useColorHarmonies } from "./useColorHarmonies";
import Head from "next/head";
import { Swiper, SwiperSlide } from "swiper/react";

export const ColorHarmonies = ({useHeadingTag=false}) => {
    const { tab, setTab, selectedColor, setSwiper } = useColorHarmonies();
    if (!selectedColor) return null;
    return (
        <>
            <Head>
                <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css" />
                <script src="https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js"></script>
            </Head>
            <div className="flex flex-col gap-4 overflow-x-hidden px-4 lg:px-0 pt-24">
                {
                    useHeadingTag ? (
                        <h2
                            className="text-xl font-semibold"
                            data-testid={`color-harmonies-title`}
                        >
                            <Translate keyName="color-harmonies-title" />
                        </h2>
                    ) : (
                        <span
                            className="text-xl font-semibold"
                            data-testid={`color-harmonies-title`}
                        >
                            <Translate keyName="color-harmonies-title" />
                        </span>
                    )
                }

                <Tabs tab={tab} setTab={setTab} />
                <Swiper
                    slidesPerView={1}
                    speed={600}
                    onSwiper={setSwiper}
                    className="w-full"
                    onSlideChange={(swiper) => setTab(colorSchemes[swiper.activeIndex])}
                    initialSlide={initialSlide}
                >
                    {colorSchemes.map((colorScheme) => (
                        <SwiperSlide key={colorScheme}>
                            <ColorScheme
                                label={translateFunc(`${colorScheme}-label`)}
                                colors={selectedColor[colorScheme]}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </>
    );
};
